import Drawer from '@/components/drawers'
import Loading from '@/components/widgets/Loading.vue'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    selectedId:{
      type: String,
    }
  },
  data() {
    return {
      sellProductList: [],
      loading: false,
      drawerOpened: false,
      form: {
        file: null,
        main_product_id: null
      }
    }
  },
  components: {
    Loading,
    Drawer
  },
  mixins: [validationMixin],
  validations: {
    form: {
      file: { required },
      main_product_id: { required }
    }
  },
  watch: {
    'opened'(n, o) {
      this.onInitSellProductTypeList()
      if (n) {
        this.drawerOpened = n
      }
    }
  },
  methods: {
    onCloseDrawer(event) {
      this.drawerOpened = false
      this.form.file = null
      this.form.main_product_id = null
      setTimeout(() => {
        this.$v.$reset()
      }, 500)
      this.$emit('close-event', { 
        status: true
      })
    },
    async onSubmitForm() {
      try {
        this.$v.form.$touch()
        if (this.$v.form.$anyError) {
          return
        }

        this.loading = true
        const formData = new FormData()
        formData.append('file', this.form.file)
        formData.append('main_product_id', this.form.main_product_id)
        await this.$axios.post(this.$host + "/api/v1/uploadSkuExcel", formData,{
          headers: {
            "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
          }
        })

        this.loading = false
        this.$swal({
          width: "29rem",
          padding: '1.825em',
          html: '<div class="d-flex flex-row align-items-center">' +
            '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>'+
            '<div class="d-flex flex-column">'+
            '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>'+
            `<span class="text-base text-left text-gray-500">บันทึกข้อมูลเรียบร้อยแล้ว</span>`+
            '</div>'+
          '</div>',
            allowOutsideClick: false,
            focusConfirm: false,
            customClass: {
              popup: 'swal2-custom-rounded',
              closeButton: 'text-3xl swal2-custom-close',
              actions: 'justify-content-end',
              contant: 'd-flex flex-row justify-content-around px-2',
              title: 'd-none',
              confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
              cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
            },
            showCancelButton: false,
            confirmButtonText: "ตกลง",
            cancelButtonText: "ยกเลิก",
            showCloseButton: true,
        }).then(result => {
          this.loading = false
          this.onCloseDrawer()
          window.location.reload()
        })
      } catch (error) {
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
      }
    },
    async onInitSellProductTypeList() {
      try {
        const result = await this.$axios.get(
          `${this.$host}/api/v1/product-types`
        )
        if (result.status === 200) {
          const data = result.data.data
          this.sellProductList = data
        }
      } catch (error) {
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
  }
}